import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

export interface Deal {
  title: string;
  url: string;
  img: string;
  source?: string; // 'epic' ou 'steam'
  price?: number;  // Prix en euros
  originalPrice?: number; // Prix original avant réduction
  rating?: string; // Note du jeu (ex: "Très positive")
  ratingPercent?: number; // Pourcentage d'évaluations positives
  otherDeals?: Deal[]; // Autres offres pour le même jeu (multi-boutiques)
  cleanTitle?: string; // Titre sans suffixe (pour déduplication)
}

/**
 * Fetches deals solely from Firebase Cache.
 * The cache is now updated automatically by a scheduled Cloud Function (Server-side).
 */
export async function fetchAllFreeGames(): Promise<{ deals: Deal[], lastUpdated: Date | null }> {
  const CACHE_COLLECTION = 'app_cache';
  const CACHE_DOC_ID = 'deals_v7';

  try {
    const docRef = doc(db, CACHE_COLLECTION, CACHE_DOC_ID);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data() as { lastUpdated: any, deals: Deal[] };
      // Convert Firestore Timestamp to Date
      const lastUpdatedDate = data.lastUpdated?.toDate ? data.lastUpdated.toDate() : new Date(data.lastUpdated);
      
      console.log('Serving deals from Cloud Function Cache (updated: ' + lastUpdatedDate.toLocaleString() + ')');
      
      return { 
        deals: data.deals || [], 
        lastUpdated: lastUpdatedDate
      };
    } else {
      console.warn('No deals found in cache. The Cloud Function might not have run yet.');
      return { deals: [], lastUpdated: null };
    }
  } catch (error) {
    console.error('Error reading deals from cache:', error);
    return { deals: [], lastUpdated: null };
  }
}
